import TransitApi from './base'

export default {
  async filters() {
    return (await TransitApi.getSecureInstance().get('/client-transit/filters'))
      .data
  },
  async list(params) {
    const api = TransitApi.getSecureInstance()
    const query = new URLSearchParams(params).toString()
    return (await api.get(`/client-transit?${query}`)).data
  },
  async products(id) {
    return (await TransitApi.getSecureInstance().get(
      `/client-transit/${id}/products`
    )).data
  },
  async documents(id, step) {
    return (await TransitApi.getSecureInstance().get(
      `/client-transit/${id}/documents`,
      { params: { step } }
    )).data.documents
  },
  async pay(id, amount, file) {
    const form = new FormData()
    form.append('taxAmount', amount)
    form.append('file', file)
    return (await TransitApi.getSecureInstanceMultipart().post(
      `/client-transit/${id}/tax-payment`,
      form
    )).data
  },
}
